const BLOB_EXPIRED_MESSAGE = '本地缓存图片已失效，请重新选择或重新生成图片'
const BLOB_CONVERT_FAILED_MESSAGE = '本地缓存图片转换失败，请重新选择图片'
const UNSUPPORTED_PROTOCOL_MESSAGE = '仅支持 blob:、data:、https: 图片地址'

const blobToDataUri = async (blobUrl) => {
  let response
  try {
    response = await fetch(blobUrl)
  } catch (error) {
    throw new Error(BLOB_EXPIRED_MESSAGE)
  }

  if (!response.ok) {
    throw new Error(BLOB_EXPIRED_MESSAGE)
  }

  let blob
  try {
    blob = await response.blob()
  } catch (error) {
    throw new Error(BLOB_EXPIRED_MESSAGE)
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = reader.result
      if (typeof result !== 'string' || !result.startsWith('data:')) {
        reject(new Error(BLOB_CONVERT_FAILED_MESSAGE))
        return
      }
      resolve(result)
    }
    reader.onerror = () => reject(new Error(BLOB_CONVERT_FAILED_MESSAGE))
    reader.readAsDataURL(blob)
  })
}

export const normalizeImageRefForServer = async (rawRef) => {
  if (typeof rawRef !== 'string' || !rawRef.trim()) {
    throw new Error('图片引用不能为空')
  }

  const ref = rawRef.trim()
  if (ref.startsWith('data:') || ref.startsWith('https://')) {
    return ref
  }
  if (ref.startsWith('blob:')) {
    return blobToDataUri(ref)
  }
  throw new Error(UNSUPPORTED_PROTOCOL_MESSAGE)
}

export const normalizeImageRefsForServer = async (refs) => {
  if (!Array.isArray(refs)) {
    throw new Error('图片列表格式不正确')
  }
  return Promise.all(refs.map((ref) => normalizeImageRefForServer(ref)))
}
